import Analytics from '@web/services/Analytics/Analytics'

/// События для главной страницы

/**
 * Событие открытия главной страницы
 * @param userId - ID пользователя
 * Отправляет: action: 'main_open', user_id, event_date
 */
export function analyticsEventMainOpen (userId: string): void {
  Analytics.send({
    action: 'main_open',
    user_id: userId,
    event_date: new Date().toISOString(),
    when_trigger: 'При загрузке главной страницы',
    target: 'Отслеживание входов',
    test_lk: 'true'
  })
}

/**
 * Событие показа баннера на главной странице
 * @param userId - ID пользователя
 * @param bannerId - ID баннера
 * @param position - позиция баннера
 * Отправляет: action: 'banner_view', user_id, banner_id, position, event_date
 */
export function analyticsEventBannerView ({ userId, bannerId, position, promo }: { userId: string, bannerId: string, position: string, promo: string }): void {
  Analytics.send({
    action: 'banner_view',
    user_id: userId,
    banner_id: bannerId,
    position,
    event_date: new Date().toISOString(),
    when_trigger: 'Когда показывается баннер',
    target: 'Отслеживание показов баннеров',
    utm_source: 'lk',
    utm_medium: 'banner',
    utm_campaign: position,
    utm_term: bannerId,
    promo,
    test_lk: 'true'
  })
}

/**
 * Событие клика по баннеру на главной странице
 * @param userId - ID пользователя
 * @param bannerId - ID баннера
 * @param position - позиция баннера
 * Отправляет: action: 'banner_click', user_id, banner_id, position, event_date
 */
export function analyticsEventBannerClick ({ userId, bannerId, position, promo }: { userId: string, bannerId: string, position: string, promo: string }): void {
  Analytics.send({
    action: 'banner_click',
    user_id: userId,
    banner_id: bannerId,
    position,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по баннеру',
    target: 'Переходы по баннерам',
    utm_source: 'lk',
    utm_medium: 'banner',
    utm_campaign: position,
    utm_term: bannerId,
    promo,
    test_lk: 'true'
  })
}

/**
 * Событие клика по категории из блока "Больше категорий"
 * @param userId - ID пользователя
 * @param categoryName - название категории
 * Отправляет: action: 'category_click', user_id, category_name, event_date
 */
export function analyticsEventCategoryClick ({ userId, categoryName }: { userId: string, categoryName: string }): void {
  Analytics.send({
    action: 'category_click',
    user_id: userId,
    category_name: categoryName,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по тегу из блока “Больше категорий”',
    target: 'Интересы пользователя',
    test_lk: 'true'
  })
}

/**
 * Событие просмотра карточки курса
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param categoryName - название категории
 * Отправляет: action: 'course_card_view', user_id, course_page_id, category_name, event_date
 */
export function analyticsEventCourseCardView ({ userId, coursePageId, categoryName }: { userId: string, coursePageId: string, categoryName: string }): void {
  Analytics.send({
    action: 'course_card_view',
    user_id: userId,
    course_page_id: coursePageId,
    category_name: categoryName,
    event_date: new Date().toISOString(),
    when_trigger: 'Видимость карточек определенной категории',
    target: 'Вовлеченность в контент',
    test_lk: 'true'
  })
}

/**
 * Событие клика по карточке курса
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param categoryName - название категории
 * Отправляет: action: 'course_card_click', user_id, course_page_id, category_name, event_date
 */
export function analyticsEventCourseCardClick ({ userId, coursePageId, categoryName }: { userId: string, coursePageId: string, categoryName: string }): void {
  Analytics.send({
    action: 'course_card_click',
    user_id: userId,
    course_page_id: coursePageId,
    category_name: categoryName,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по карточке курса',
    target: 'Интересы пользователя',
    test_lk: 'true'
  })
}

/**
 * Событие глубины прокрутки главной страницы
 * @param userId - ID пользователя
 * @param scrollPercent - процент прокрутки ('25', '50', '75', '100')
 * Отправляет: action: 'scroll_depth', user_id, scroll_percent, event_date
 */
export function analyticsEventScrollDepth ({ userId, scrollPercent }: { userId: string, scrollPercent: string }): void {
  Analytics.send({
    action: 'scroll_depth',
    user_id: userId,
    scroll_percent: scrollPercent,
    event_date: new Date().toISOString(),
    when_trigger: 'Пользователь проскроллил страницу (25/50/75/100%)',
    target: 'Измерение вовлечённости',
    test_lk: 'true'
  })
}

/// События для страницы курса

/**
 * Событие открытия промо-лендинга курса
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'course_page_open', user_id, course_page_id, event_date
 */
export function analyticsEventCoursePageOpen ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'course_page_open',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'При открытии промо лендинга курса (когда кликают на карточку курса с главной)',
    target: 'Построение воронки',
    test_lk: 'true'
  })
}

/**
 * Событие клика по баннеру "Попробовать бесплатно"
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'banner_cta_try_free_click', user_id, course_page_id, event_date
 */
export function analyticsEventBannerCtaTryFreeClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'banner_cta_try_free_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по баннеру "Попробовать бесплатно"',
    target: 'переходы по баннерам',
    test_lk: 'true'
  })
}

/**
 * Событие клика по закрепленной кнопке "Попробовать бесплатно"
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'fix_cta_try_free_click', user_id, course_page_id, event_date
 */
export function analyticsEventFixCtaTryFreeClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'fix_cta_try_free_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик на закрепе по кнопке "попробовать бесплатно"',
    target: 'Переход в пэйвол',
    test_lk: 'true'
  })
}

/**
 * Событие клика по зафиксированной кнопке внизу страницы в мобильной версии
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'fix_mobile_cta_try_free_click', user_id, course_page_id, event_date
 */
export function analyticsEventFixMobileCtaTryFreeClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'fix_mobile_cta_try_free_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по зафиксированной кнопке внизу страницы в мобильной версии',
    target: 'Переход в пэйвол',
    test_lk: 'true'
  })
}

/**
 * Событие клика по закрепленной кнопке "Получить доступ"
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'fix_cta_buy_course_click', user_id, course_page_id, event_date
 */
export function analyticsEventFixCtaBuyCourseClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'fix_cta_buy_course_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик на закрепе по кнопке "получить доступ"',
    target: 'Интерес к покупке курса',
    test_lk: 'true'
  })
}

/**
 * Событие клика по кнопке "Назад" на странице курса
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'back_to_main_click', user_id, course_page_id, event_date
 */
export function analyticsEventBackToMainClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'back_to_main_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по кнопке назад',
    target: 'Навигация',
    test_lk: 'true'
  })
}

/// События для пэйволла

/**
 * Событие прокрутки пэйволла
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param scrollPercent - процент прокрутки
 * Отправляет: action: 'paywall_scroll_depth', user_id, course_page_id, scroll_percent, event_date
 */
export function analyticsEventPaywallScrollDepth ({ userId, coursePageId, scrollPercent }: { userId: string, scrollPercent: string, coursePageId: string }): void {
  Analytics.send({
    action: 'paywall_scroll_depth',
    user_id: userId,
    course_page_id: coursePageId,
    scroll_percent: scrollPercent,
    event_date: new Date().toISOString(),
    when_trigger: 'Прокрутка пэйвола',
    target: 'Насколько изучают экран',
    test_lk: 'true'
  })
}

/**
 * Событие клика по кнопке "Начать пробный период" на пэйволле
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'paywall_cta_click', user_id, course_page_id, event_date
 */
export function analyticsEventPaywallCtaClick ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'paywall_cta_click',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик “Начать пробный период”',
    target: 'Конверсия в переход на форму оплаты',
    test_lk: 'true'
  })
}

/**
 * Событие закрытия пэйволла
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * Отправляет: action: 'paywall_close', user_id, course_page_id, event_date
 */
export function analyticsEventPaywallClose ({ userId, coursePageId }: { userId: string, coursePageId: string }): void {
  Analytics.send({
    action: 'paywall_close',
    user_id: userId,
    course_page_id: coursePageId,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик на крестик закрытия пэйвола',
    target: 'Навигация',
    test_lk: 'true'
  })
}

/// События для модальных окон

/**
 * Событие показа модального окна
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param modalName - название модального окна
 * Отправляет: action: 'modal_view', user_id, course_page_id, modal_name, event_date
 */
export function analyticsEventModalView ({ userId, coursePageId = 'home', modalName = 'quiz' }: { userId: string, coursePageId?: string, modalName?: string }): void {
  Analytics.send({
    action: 'modal_view',
    user_id: userId,
    course_page_id: coursePageId,
    modal_name: modalName,
    event_date: new Date().toISOString(),
    when_trigger: 'Показ модального окна',
    target: 'Отслеживание количества показов',
    test_lk: 'true'
  })
}

/**
 * Событие клика по модальному окну
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param modalName - название модального окна
 * Отправляет: action: 'modal_click', user_id, course_page_id, modal_name, event_date
 */
export function analyticsEventModalClick ({ userId, coursePageId = 'home', modalName = 'quiz' }: { userId: string, coursePageId?: string, modalName?: string }): void {
  Analytics.send({
    action: 'modal_click',
    user_id: userId,
    course_page_id: coursePageId,
    modal_name: modalName,
    event_date: new Date().toISOString(),
    when_trigger: 'Клик по нему',
    target: 'Конверсия в переход',
    test_lk: 'true'
  })
}

/**
 * Событие закрытия модального окна
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param modalName - название модального окна
 * Отправляет: action: 'modal_close', user_id, course_page_id, modal_name, event_date
 */
export function analyticsEventModalClose ({ userId, coursePageId = 'home', modalName = 'quiz' }: { userId: string, coursePageId?: string, modalName?: string }): void {
  Analytics.send({
    action: 'modal_close',
    user_id: userId,
    course_page_id: coursePageId,
    modal_name: modalName,
    event_date: new Date().toISOString(),
    when_trigger: 'Закрытие окна',
    target: 'Конверсия в закрытие',
    test_lk: 'true'
  })
}

/**
 * Событие закрытия модального окна
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param modalName - название модального окна
 * Отправляет: action: 'modal_qwiz_close', user_id, course_page_id, modal_name, event_date
 */
export function analyticsEventModalQwizClose ({ userId, coursePageId = 'home', modalName = 'quiz' }: { userId: string, coursePageId?: string, modalName?: string }): void {
  Analytics.send({
    action: 'modal_qwiz_close',
    user_id: userId,
    course_page_id: coursePageId,
    modal_name: modalName,
    event_date: new Date().toISOString(),
    when_trigger: 'Закрытие окна',
    target: 'Конверсия в закрытие',
    test_lk: 'true'
  })
}

/**
 * Событие выбора "Больше не показывать" для модального окна
 * @param userId - ID пользователя
 * @param coursePageId - ID страницы курса
 * @param modalName - название модального окна
 * Отправляет: action: 'modal_dont_ask_again', user_id, course_page_id, modal_name, event_date
 */
export function analyticsEventModalNeverShow ({ userId, coursePageId = 'home', modalName = 'quiz' }: { userId: string, coursePageId?: string, modalName?: string }): void {
  Analytics.send({
    action: 'modal_never_show',
    user_id: userId,
    course_page_id: coursePageId,
    modal_name: modalName,
    event_date: new Date().toISOString(),
    when_trigger: 'Выбор "Больше не показывать"',
    target: 'Отслеживание отказов от показа',
    test_lk: 'true'
  })
}

/// События для коротких курсов

/**
 * Событие нажатия на кнопку "Добавить в мои курсы"
 * @param userId - ID пользователя
 * @param courseId - ID курса
 * @param courseName - название курса
 * Отправляет: action: 'add_course_SS', user_id, course_id, course_name, event_date
 */
export function analyticsEventAddCourseSS ({ userId, courseId, courseName }: { userId: string, courseId: string, courseName: string }): void {
  Analytics.send({
    action: 'add_course_SS',
    user_id: userId,
    course_id: courseId,
    course_name: courseName,
    event_date: new Date().toISOString(),
    when_trigger: 'Нажатие на "Добавить в мои курсы"',
    target: 'Отслеживание добавления курсов',
    test_lk: 'true'
  })
}

/**
 * Событие успешного добавления курса
 * @param userId - ID пользователя
 * @param courseId - ID курса
 * @param courseName - название курса
 * Отправляет: action: 'course_added_SS', user_id, course_id, course_name, event_date
 */
export function analyticsEventCourseAddedSS ({ userId, courseId, courseName }: { userId: string, courseId: string, courseName: string }): void {
  Analytics.send({
    action: 'course_added_SS',
    user_id: userId,
    course_id: courseId,
    course_name: courseName,
    event_date: new Date().toISOString(),
    when_trigger: 'Когда курс был добавлен',
    target: 'Подтверждение добавления курса',
    test_lk: 'true'
  })
}

/**
 * Событие нажатия на кнопку "Перейти в курс"
 * @param userId - ID пользователя
 * @param courseId - ID курса
 * @param courseName - название курса
 * Отправляет: action: 'add_course_SS_go', user_id, course_id, course_name, event_date
 */
export function analyticsEventAddCourseSSGo ({ userId, courseId, courseName }: { userId: string, courseId: string, courseName: string }): void {
  Analytics.send({
    action: 'add_course_SS_go',
    user_id: userId,
    course_id: courseId,
    course_name: courseName,
    event_date: new Date().toISOString(),
    when_trigger: 'Нажатие на кнопку "Перейти в курс"',
    target: 'Переход в курс',
    test_lk: 'true'
  })
}
